module.exports = __webpack_public_path__ + "media/icons/figure-6ba895b9.png";